module.exports = __webpack_public_path__ + "static/ordinace_015-04f57b3480a0f9a0c22752d74bec820b.jpg";